import { useTranslation } from 'react-i18next';

import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

import { Changes, DiffType } from './Changes';

export const VersionChanges = ({ versionsDiff, loadingChanges, padding = true }) => {
  const { t } = useTranslation();

  if (loadingChanges) {
    return [...Array(2)].map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <Skeleton key={index} className="h-5 w-full" />
    ));
  }

  return (
    <ul
      className={cn(
        "flex w-full flex-row flex-wrap items-center gap-2 [&>li:not(:last-of-type)]:after:mx-2 [&>li:not(:last-of-type)]:after:text-[10px] [&>li:not(:last-of-type)]:after:text-(--muted-foreground) [&>li:not(:last-of-type)]:after:content-['•']",
        { 'pb-6': padding }
      )}
    >
      {versionsDiff.length > 0 ? (
        versionsDiff.map((version) => {
          if (version.component === 'users') {
            const allUsers = [...version.added, ...version.modified, ...version.removed];
            return (
              <Changes
                key={'users-all'}
                component={version.component}
                type={'all' as DiffType}
                changes={allUsers}
              />
            );
          } else {
            const relevantKeys = Object.keys(version).filter(
              (key) => key !== 'component' && version[key].length
            );

            if (relevantKeys.length === 0) {
              return null;
            }

            return (
              <>
                {relevantKeys.map((key) => (
                  <Changes
                    key={key.concat(version.component)}
                    component={version.component}
                    type={key as DiffType}
                    changes={version[key]}
                  />
                ))}
              </>
            );
          }
        })
      ) : (
        <span className="text-sm leading-5 font-normal text-muted-foreground">
          {t('versions.no_changes')}
        </span>
      )}
    </ul>
  );
};
